export default {	
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(),
	resultList : []
};

function SEARCH_PARAMS() {
	return {
		deptCd: '',
		deptNm: ''		
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO };
